var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.752 12C18.752 12.4142 18.4162 12.75 18.002 12.75L6.00195 12.75C5.58774 12.75 5.25195 12.4142 5.25195 12C5.25195 11.5858 5.58774 11.25 6.00195 11.25L18.002 11.25C18.4162 11.25 18.752 11.5858 18.752 12Z","fill":"currentColor"}));
}

Minus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
